type GoAiguaButtonProps = {
  text: string;
  status?: "enabled" | "disabled";
  onClick?: () => any;
  className?: string;
};

const GoAiguaButton = ({
  text,
  status = "enabled",
  onClick,
  className = "",
}: GoAiguaButtonProps) => {
  const generateButtonClassesFromModifiers = () => {
    let baseClass = "c-goaigua-button";

    if (status !== "enabled") {
      baseClass += " --disabled";
    }

    return baseClass + " " + className;
  };

  return (
    <button
      className={generateButtonClassesFromModifiers()}
      onClick={onClick ? () => onClick() : void 0}
    >
      {text}
    </button>
  );
};

export default GoAiguaButton;
